import { createFileRoute, Navigate } from '@tanstack/react-router';
import { NewBusinessPage } from '../components/pages/HomePage/NewBusinessPage';
import { useApiState } from '../contexts/ApiContext';

function SwitchGuard() {
  const state = useApiState();
  switch (state) {
    case 'authenticated':
      return <NewBusinessPage />;
    case 'unauthenticated':
      return <Navigate to="/auth" replace />;

    default:
      return null;
  }
}

export const Route = createFileRoute('/new-business')({
  component: SwitchGuard,
});
